import React, { useEffect, useState } from "react";
import { MapPin, Clock } from "lucide-react";
import api from "@/lib/api";
import { PageHero } from "@/components/Shared";
import VenueLeaderboard from "@/components/VenueLeaderboard";

export default function WhereToPlay() {
  const [venues, setVenues] = useState([]);
  useEffect(() => { api.get("/venues").then((r) => setVenues(r.data)).catch(() => {}); }, []);

  return (
    <div data-testid="where-to-play-page">
      <PageHero
        title="Where to Play"
        subtitle="Legends tournaments run weekly at venues across Victoria. Find your local room and its regular game night."
        image="https://images.unsplash.com/photo-1504279807002-09854ccc9b6c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600"
        testId="where-to-play-hero"
      />
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24 grid md:grid-cols-3 gap-8">
        {venues.map((v, i) => (
          <div key={v.id} className="bg-navy-paper border border-slate-800 hover:border-gold/50 transition-all duration-300 hover:-translate-y-1 overflow-hidden animate-fade-up" style={{ animationDelay: `${i * 90}ms` }} data-testid={`venue-card-${v.id}`}>
            <div className="h-52 overflow-hidden">
              <img src={v.image} alt={v.name} className="w-full h-full object-cover" />
            </div>
            <div className="p-6">
              <h3 className="font-display text-xl font-bold text-white">{v.name}</h3>
              <p className="text-gold text-sm mt-1 flex items-center gap-1.5"><MapPin className="w-3.5 h-3.5" /> {v.city}</p>
              <p className="text-slate-400 text-sm mt-3">{v.description}</p>
              <div className="mt-4 pt-4 border-t border-white/5 space-y-2 text-sm">
                <p className="text-slate-300 flex items-center gap-2"><Clock className="w-4 h-4 text-gold" /> {v.schedule}</p>
                <p className="text-slate-500 text-xs">{v.address}</p>
                <div className="flex flex-wrap gap-3 pt-1">
                  {v.address && <a href={`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(v.address.trim())}&travelmode=driving`} target="_blank" rel="noreferrer" className="text-gold text-xs underline" data-testid={`venue-directions-${v.id}`}>Get directions →</a>}
                  {v.website && <a href={v.website} target="_blank" rel="noreferrer" className="text-gold text-xs underline" data-testid={`venue-website-${v.id}`}>Visit website →</a>}
                </div>
              </div>
              <VenueLeaderboard venueName={v.city} />
            </div>
          </div>
        ))}
        {venues.length === 0 && <p className="text-slate-400 col-span-3 text-center py-20">Venues coming soon.</p>}
      </div>
    </div>
  );
}
